import { useLocation } from '@reach/router';
import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { IPageProps } from '@folx-types/flow-steps';

import ReactivateMembership, {
	IReactivateMembershipPageContent,
} from './ReactivateMembership.component';

interface IReactivateMembershipPageProps extends IPageProps {}

const ReactivateMembershipPage: FC<IReactivateMembershipPageProps> = ({ path }) => {
	const { pageContent, productFlowsCopy } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "mssp-reactivate-membership-page" }) {
				heading
				description
			}
			productFlowsCopy: butterPage(slug: { eq: "mssp-product-flows-reactivate-membership-page" }) {
				heading
				description
			}
		}
	`);

	const location = useLocation();
	const state = location.state as { source?: 'default' | 'product-flow' } | undefined;
	const source = state?.source ?? 'default';

	const refinedContent: IReactivateMembershipPageContent = keysToCamel(
		source === 'product-flow' ? productFlowsCopy : pageContent
	) as IReactivateMembershipPageContent;

	return <ReactivateMembership pageContent={refinedContent} path={path} />;
};

export default ReactivateMembershipPage;
